module.exports = __webpack_public_path__ + "static/media/noun_drop_1235520.f262652f.svg";